import isObject from 'lodash/isObject';

define([
  'handlebars/dist/handlebars',
  'jquery',
  '../lib/moment'
], (HandlebarsAmd, $, moment) => {
  const Handlebars = HandlebarsAmd.default; // /????

  const operators = {
    eq(l, r) {
      // eslint-disable-next-line eqeqeq
      return l == r;
    },
    eqeq(l, r) {
      return l === r;
    },
    neq(l, r) {
      // eslint-disable-next-line eqeqeq
      return l != r;
    },
    neqeq(l, r) {
      return l !== r;
    },
    lt(l, r) {
      return l < r;
    },
    gt(l, r) {
      return l > r;
    },
    lte(l, r) {
      return l <= r;
    },
    gte(l, r) {
      return l >= r;
    },
    typeof(l, r) {
      // eslint-disable-next-line valid-typeof
      return typeof l === r;
    },
    regexp(l, r) {
      return (l && r && (l.match(new RegExp(r)) !== null));
    },
    mod(l, r) {
      return l % r;
    }
  };

  operators['=='] = operators.eq;
  operators['==='] = operators.eqeq;
  operators['!='] = operators.neq;
  operators['!=='] = operators.neqeq;
  operators['>'] = operators.lt;
  operators['>'] = operators.gt;
  operators['<='] = operators.lte;
  operators['>='] = operators.gte;
  operators['%'] = operators.mod;

  Handlebars.registerHelper('compare', function compare(lvalue, operator, rvalue, options) {
    // eslint-disable-next-line prefer-rest-params
    if ($.makeArray(arguments).length < 3) {
      throw new Error('Handlerbars Helper \'compare\' needs 2 parameters');
    }

    if (options === undefined) {
      options = rvalue;
      rvalue = operator;
      operator = 'eq';
    }

    if (!operators[operator]) {
      throw new Error(`Handlerbars Helper 'compare' doesn't know the operator ${operator}`);
    }

    if (operators[operator](lvalue, rvalue)) {
      return options.fn(this);
    }
    return options.inverse(this);
  });

  Handlebars.registerHelper('isObject', function isObj(value, options) {
    return isObject(value) ? options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper('dateFormat', (date, format) =>  {
    return moment(date).tz('Europe/Amsterdam').format(format || '');
  });

  return Handlebars;
});
